import config from '@bedrock-rdk/config';

const appEnv = process.env.APP_ENV;

export const removeSplashScreen = () => {
  const splash = document.getElementById('splashscreen');

  if (!splash) {
    return;
  }

  if (!window.splashRemovalTimeout) {
    const transition = 'opacity .75s ease-out';
    splash.style.transition = transition;
    splash.setAttribute('style', `-moz-transition: ${transition};`);
    splash.setAttribute('style', `-webkit-transition: ${transition};`);
    splash.style.opacity = '0';

    window.splashRemovalTimeout = setTimeout(() => document.body.removeChild(splash), 1000);
  }
};

export const getTenant = () => config.tenant;

export const getEnv = () => appEnv || '';

// NOTE: those keys will not appear at the globalsToPreserve since they are added at the very app start
export const GLOBALS = [
  // Webpack's stuff
  'webpackJsonpapp-bedrock-rdk',
  'webpackChunkapp_bedrock_rdk',
  // The i18n tool
  'sprintf',
  'vsprintf',
  // Lodash
  '_',
  // In case we are testing in dev mode (sic!)
  'devToolsOptions',
  // Loose ends :)
  'globalsToPreserve',
  'splashRemovalTimeout',
];

export const preserveGlobals = () => {
  window.globalsToPreserve = Object.keys(window);
};

export const cleanupGlobals = () => {
  if (window.splashRemovalTimeout) {
    clearTimeout(window.splashRemovalTimeout);
  }

  // No need to do it twice, the globals were already cleaned up
  if (!window.globalsToPreserve) {
    return;
  }

  const keysToCleanup = Object.keys(window).filter(key => !window.globalsToPreserve.includes(key));
  keysToCleanup.forEach(key => {
    try {
      delete window[key];
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(`[app.utils] Can not remove property "${key}" in the window object`);
    }
  });

  GLOBALS.forEach(key => {
    delete window[key];
  });

  // Should be done by the Metrological store itself...well, we know how "reliable" it is
  if (process.env.APP_ID) {
    const id = 'APP_'.concat(process.env.APP_ID.replace(/[^0-9a-zA-Z_$]/g, '_'));
    delete window[id];
  }
};

export const cleanupConfig = () => {
  Object.keys(config).forEach(key => {
    delete config[key];
  });
};
